import Service from "../Service";

const resource = "lotrejectedbymature/"

export default {

    list(obj, requestID) {
        return Service.post(resource + "list", obj, {
            params: { requestID },
        });
    },

    PrfLotRejectedByMatureExcel(obj, requestID) {
        return Service.post(resource + "PrfLotRejectedByMatureExcel", obj, {
            responseType: "blob",
            headers: {
                "Content-Type": "application/json",
            },
            params: { requestID },
        });
    }

}